<template>
	<div class="contentMainDiv">
		<div style="color:red;">ページにアクセスできません。</div>	
	</div>
</template>

